import { Legs, CoffeeTableLegs } from './legs';
import { ShaderNBox } from '../shaders/legs/shader_n_box';
import { ProductType } from '@/store/modules/product';
import { ShaderNOkragla } from '../shaders/legs/shader_n_okagla';
import { ShaderNStGiety } from '../shaders/legs/shader_n_st_giety';
import { ShaderNStPrzesun } from '../shaders/legs/shader_n_st_przesun';
import { ShaderNStScieta } from '../shaders/legs/shader_n_st_scieta';
import { ShaderNStStozek } from '../shaders/legs/shader_n_st_stozek';
import { ShaderNStozek } from '../shaders/legs/shader_n_stozek';
import { ShaderNWalec } from '../shaders/legs/shader_n_walec';
import { ShaderNPlozy } from '../shaders/legs/shader_n_plozy';
import { ShaderNStBox } from '../shaders/legs/shader_n_st_box';
import { ShaderNStProsta } from '../shaders/legs/shader_n_st_prosta';

export const coffeeTableLegs = [
    new CoffeeTableLegs(
        `skaw_n_box_{w}.gltf`,
        `skaw_n_box_{w}_light.jpg`,
        new ShaderNBox(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_noga_prosta_debowa_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_okragla_{w}.gltf`,
        `skaw_n_okragla_{w}_light.jpg`,
        new ShaderNOkragla(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_noga_metalowa_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_plozy_{w}.gltf`,
        `skaw_n_plozy_{w}_light.jpg`,
        new ShaderNPlozy(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_ploza_metalowa_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_st_giety_{w}.gltf`,
        `skaw_n_st_giety_{w}_light.jpg`,
        new ShaderNStGiety(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_stelaz_giety_metalowy_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_st_box_{w}.gltf`,
        `skaw_n_st_box_{w}_light.jpg`,
        new ShaderNStBox(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_stelaz_skosny_drewniany_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_st_prosta_{w}.gltf`,
        `skaw_n_st_prosta_{w}_light.jpg`,
        new ShaderNStProsta(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_stelaz_prosty_metalowy_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_st_przesun_{w}.gltf`,
        `skaw_n_st_przesun_{w}_light.jpg`,
        new ShaderNStPrzesun(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_stelaz_skosny_metalowy_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_st_scieta_{w}.gltf`,
        `skaw_n_st_scieta_{w}_light.jpg`,
        new ShaderNStScieta(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_stelaz_skosny_debowy_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_st_stozek_{w}.gltf`,
        `skaw_n_st_stozek_{w}_light.jpg`,
        new ShaderNStStozek(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_stelaz_skosny_drewniany_stozek_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_stozek_{w}.gltf`,
        `skaw_n_stozek_{w}_light.jpg`,
        new ShaderNStozek(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_noga_stozek_drewniana_icon.jpg`,
    ),
    new CoffeeTableLegs(
        `skaw_n_walec_{w}.gltf`,
        `skaw_n_walec_{w}_light.jpg`,
        new ShaderNWalec(),
        0,
        ProductType.COFFEE_TABLE,
        `skaw_noga_walec_debowa_icon.jpg`,
    ),
];
